require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

//.CommonJS
var CSSOM = {}; ///CommonJS

/**
 * @constructor
 * @see http://www.w3.org/TR/DOM-Level-2-Style/css.html#CSS-CSSValue
 *
 * TODO: add if needed
 */

CSSOM.CSSValue = function CSSValue() {};

CSSOM.CSSValue.prototype = {
  constructor: CSSOM.CSSValue,

  // @see: http://www.w3.org/TR/DOM-Level-2-Style/css.html#CSS-CSSValue
  set cssText(text) {
    var name = this._getConstructorName();

    throw new Error('DOMException: property "cssText" of "' + name + '" is readonly and can not be replaced with "' + text + '"!');
  },

  get cssText() {
    var name = this._getConstructorName();

    throw new Error('getter "cssText" of "' + name + '" is not implemented!');
  },

  _getConstructorName: function _getConstructorName() {
    var s = this.constructor.toString(),
        c = s.match(/function\s([^\(]+)/),
        name = c[1];
    return name;
  }
}; //.CommonJS

exports.CSSValue = CSSOM.CSSValue; ///CommonJS